// INFO: не забывать добавлять `REACT_APP_` для переменных, иначе они не пробросятся

export const PADDLE_VENDOR_ID = JSON.parse(process.env.REACT_APP_PADDLE_VENDOR_ID || `false`)
export const PADDLE_SANDBOX = JSON.parse(process.env.REACT_APP_PADDLE_SANDBOX || `false`)

export const API_URL = process.env.REACT_APP_API_URL || `https://api.breathhh.app`
// export const API_URL = process.env.REACT_APP_API_URL || `https://api.breathhh-staging.dev.yahht.com`
export const APP_DOMAIN = process.env.REACT_APP_DOMAIN || `breathhh.app`
